import { render, staticRenderFns } from "./questionBankLeft.vue?vue&type=template&id=0ac270af&scoped=true&"
import script from "./questionBankLeft.vue?vue&type=script&lang=js&"
export * from "./questionBankLeft.vue?vue&type=script&lang=js&"
import style0 from "./questionBankLeft.vue?vue&type=style&index=0&id=0ac270af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac270af",
  null
  
)

export default component.exports